// actions.js
import { SET_EMPLOYEE_DATA } from './types';

export const setEmployeeData = (data) => {
  return {
    type: SET_EMPLOYEE_DATA,
    payload: data
  };
};
